import type {ReactElement} from 'react';
import React from 'react';
import {BaseLanguageNotSupportedOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-language-not-supported-option';
import {getRecommendedFont} from '@Libraries/font-library';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTextStylesActiveItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesActiveItem';

export function LanguageNotSupportedByTextFontOption(): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const fontFamily = useGetKeyFromTextStylesActiveItem('fontFamily');
  const fontScript = useGetKeyFromTextStylesActiveItem('script');

  if (!activeItem || fontFamily === undefined || fontScript === undefined) {
    return null;
  }

  if (!activeItem.isText() && !activeItem.isTab()) {
    return null;
  }

  const onClickUseRecommendedFont = (): void => {
    const recommendedFont = getRecommendedFont(fontScript);

    void activeItem.updateFromObject({
      textStyles: {
        fontFamily: recommendedFont,
      },
    });
  };

  return <BaseLanguageNotSupportedOption selectedFontFamily={fontFamily} onClickUseRecommendedFont={onClickUseRecommendedFont} script={fontScript} />;
}
